import React, { ReactNode, useEffect } from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";
import { getUserAgent } from "../../utils/utility";

interface IBackdrop {
  destroy?: any;
}

interface IModalMode {
  children: ReactNode;
  destroy?: any;
  hasError?: boolean;
}

const Backdrop = ({ destroy }: IBackdrop) => {
  return <BackdropStyled onClick={destroy} />;
};

export default function Modal({ children, destroy, hasError }: IModalMode) {
  useEffect(() => {
    if (getUserAgent() === "android") {
      window.closeModalAtAndroid = destroy;
    }
  }, []);

  return (
    <>
      {ReactDOM.createPortal(
        <Backdrop destroy={destroy} />,
        document.getElementById("backdrop") as Element
      )}
      {ReactDOM.createPortal(
        <ModalStyled
          style={hasError ? { animation: "shake 0.5s ease-in-out" } : {}}
        >
          {children}
        </ModalStyled>,
        document.getElementById("modal") as Element
      )}
    </>
  );
}

const BackdropStyled = styled.div`
  position: fixed;
  inset: 0;
  background: #00000066;
  z-index: 20000;
`;

const ModalStyled = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 20001;
  width: 100vw;
  max-width: 32rem;
  height: max-content;
  background-color: var(--color-white);
  border-radius: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  .title {
    font-size: 1.6rem;
    font-weight: 600;
    color: var(--color-grey-900);
  }

  .desc {
    font-size: 1.4rem;
    color: var(--color-grey-500);
    white-space: pre-line;
  }

  .buttons {
    display: flex;
    column-gap: 0.8rem;
  }

  button {
    width: 100%;
    height: 4.8rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 1rem;
    font-size: 1.4rem;
    font-weight: 600;
  }

  .secondary {
    background-color: var(--color-purple-100);
    color: var(--color-main);
  }

  .primary {
    background-color: var(--color-main);
    color: var(--color-white);
  }

  @keyframes shake {
    0%,
    100% {
      transform: translate(-48%, -50%);
    }
    10%,
    20%,
    30%,
    40%,
    50%,
    60%,
    70%,
    80%,
    90% {
      transform: translate(-50%, -50%);
    }
    15%,
    25%,
    35%,
    45%,
    55%,
    65%,
    75%,
    85%,
    95% {
      transform: translate(-52%, -50%);
    }
  }
`;
